import 'bootstrap';
import * as bootstrap from 'bootstrap';
import '@popperjs/core';

window.bootstrap = bootstrap;